module.exports = __webpack_public_path__ + "img/Reward_Footer.fb27b5f3.jpg";